import { RecursoFiltro } from 'app/entity/recurso-filtro.model';
import { Component, Input, EventEmitter, Output } from '@angular/core';
import { Validators } from '@angular/forms';
import { BaseStepComponent } from '../../base';
import { Recurso } from 'app/entity/Recurso.model';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'show-recurso',
  templateUrl: './show-recurso.component.html'
})
export class ShowRecursoComponent extends BaseStepComponent {

  @Input() recurso: RecursoFiltro;

  init() {
  }
}



// WEBPACK FOOTER //
// ./src/app/Componentes/show-recurso/show-recurso.component.ts